import React from 'react';
import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { TextConstants } from "../../../Common/TextConstants";
import { Layout } from '@singularsystems/neo-canvas-grid';
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { AppService, Types } from '../../../App/Services/AppService';
import CashReconciliationReportCriteria from './CashReconciliationReportCriteria';

@NeoReport("CashReconciliation", { category: MaintenanceReportCategories.DataValidationReports })
export default class CashReconciliationReport extends Report<CashReconciliationReportCriteria> {

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(CashReconciliationReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup 
                    appendText="fa-calendar"
                    bind={this.criteria.meta.holdingsDate} />
                <Neo.FormGroup
                    bind={this.criteria.meta.rawAccountId} />
                <Neo.FormGroup
                    bind={this.criteria.meta.maxTolerance} />
                <Neo.FormGroup
                    bind={this.criteria.meta.minTolerance} />
            </Neo.GridLayout>
        </div>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}